// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1gqfh","legacyBtn":"MutateMid_legacyBtn__2zcuX"};